<template>
  <Card :title="title" :title-level="3" show-status-bar body-class="p-0">
      <div class="list-group list-group-flush">
        <div v-for="(departure, index) in departures"
             :key="index"
             class="list-group-item"
        >
          <div class="row g-2">
            <!-- Location and Address -->
            <div class="col-12 col-sm">
              <div class="mb-1">
                <strong>{{ departure.location }}</strong>
              </div>
              <div class="text-muted small">{{ departure.address }}</div>
            </div>

            <!-- Date and Time -->
            <div class="col-auto">
              <div class="text-sm-end">
                <div>{{ departure.date_formatted?.replace(/-/g,'/') || '' }} {{ departure.date_time_formatted }}</div>
                <div class="text-muted small">
                  <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
                  {{ __DICT__.loadingTime }}: {{ departure.loading_time_formatted }}
                </div>
              </div>
            </div>

            <!-- Map Button -->
            <div class="col-auto ms-auto" v-if="departure.latitude && departure.longitude">
              <a :href="googleLink(departure.latitude, departure.longitude)"
                 target="_blank"
                 class="btn btn-ghost-primary btn-icon">
                <IconMapPin />
              </a>
            </div>
          </div>
        </div>
      </div>
  </Card>
</template>

<script setup>
import {IconMapPin} from '@tabler/icons-vue'
import { Card } from "@/components/atomic";

defineProps({
  departures: {
    type: Array,
    required: true
  },
  title: {
    type: String,
    required: true
  }
})

function googleLink(long, lat) {
  return `https://www.google.com/maps?q=${long},${lat}`
}
</script>